export const tutorialTexts = {
  pickCard: "Cards let you interact with the world. Just tap the card.",

  pickAction: "Excellent. Now choose your action.",

  cardOffering: "More tools for the experiment. Choose wisely... or don't. Science is messy.",

  cardOfferingMulti: "Take both cards. Next time, pick only the useful ones.",

  multipleCards: "More options this time. Pick one.",

  freeForm: "Breaking script already? Type whatever feels right. The timeline is flexible.",

  typingComplete: "This one's written for you. Next time, you'll write your own. Tap Play Card.",

  diceIntroduction: "Not every try works. Roll the dice to see what happens.",

  completed: "Well done. You're ready. Go save the world. Or destroy it. Time will tell."
};